import React from "react";
import { buildAttemptLabel, formatDate, formatTime, normalizeText, resolveActionLabel } from "./onboardingAlertsUtils";

const priorityClassNameByValue = {
  CRITICA: "is-critical",
  ALTA: "is-high",
  MEDIA: "is-medium",
  BAJA: "is-low",
};

const PRIORITY_LABELS = {
  CRITICA: "Crítica",
  ALTA: "Alta",
  MEDIA: "Media",
  BAJA: "Baja",
};

const formatActionLabel = (value) => {
  const normalized = normalizeText(value).toLocaleLowerCase("es-AR");
  return normalized ? normalized.charAt(0).toLocaleUpperCase("es-AR") + normalized.slice(1) : "";
};

export default function OnboardingAlertCard({ item, mobile = false, busy = false, onManage }) {
  const priorityKey = normalizeText(item.priority).toUpperCase();
  const priorityClassName = priorityClassNameByValue[priorityKey] || "is-neutral";
  const actionLabel = resolveActionLabel(item);
  const nextActionLabel = formatActionLabel(item.nextActionLabel);
  const nextActionDate = formatDate(item.nextActionDate);
  const nextActionTime = formatTime(item.nextActionDate);

  return (
    <article className={`onboarding-alert-card ${mobile ? "is-mobile" : ""}`}>
      <div className="onboarding-alert-card__commerce">
        <strong>{item.commerceName}</strong>
        <div className="onboarding-alert-card__meta">
          {item.cuit ? <span><b>CUIT:</b> {item.cuit}</span> : null}
          {item.terminal ? <span><b>Terminal:</b> {item.terminal}</span> : null}
          {item.commerceNumber ? <span><b>Comercio:</b> {item.commerceNumber}</span> : null}
          {item.province ? <span><b>Provincia:</b> {item.province}</span> : null}
        </div>
      </div>

      <div className="onboarding-alert-card__tracking">
        <span className="onboarding-alert-card__status-pill">{item.status}</span>
        <div className="onboarding-alert-card__detail-lines is-inline">
          {item.channel ? <span><b>Canal:</b> {item.channel}</span> : null}
          <span><b>Intento:</b> {buildAttemptLabel(item.currentAttempt, item.maxAttempts)}</span>
        </div>
      </div>

      <div className="onboarding-alert-card__next-action">
        {nextActionLabel ? (
          <div className="onboarding-alert-card__next-title">
            <strong>{nextActionLabel}</strong>{item.channel ? ` por ${item.channel}` : ""}
          </div>
        ) : null}
        <div className="onboarding-alert-card__detail-lines">
          {nextActionDate ? <span><b>Fecha:</b> {nextActionDate}</span> : null}
          {nextActionTime ? <span><b>Horario:</b> {nextActionTime}</span> : null}
        </div>
      </div>

      <div className="onboarding-alert-card__priority">
        {item.priority ? (
          <span className={`onboarding-alert-card__priority-pill ${priorityClassName}`}>
            {PRIORITY_LABELS[priorityKey] || item.priority}
          </span>
        ) : (
          <span className="onboarding-alert-card__empty">Sin prioridad</span>
        )}
      </div>

      <div className="onboarding-alert-card__responsible">
        <span className={item.responsibleName ? "" : "is-empty"}>{item.responsibleName || "Sin responsable"}</span>
      </div>

      <div className="onboarding-alert-card__actions">
        <button
          type="button"
          className="onboarding-alert-card__manage-button"
          onClick={() => onManage?.(item.raw)}
          disabled={busy}
          aria-label={`${actionLabel} ${item.commerceName}`}
        >
          {actionLabel}
        </button>
      </div>
    </article>
  );
}
